// extracted by mini-css-extract-plugin
export default {"forgotPasswordForm":"styles_forgotPasswordForm__m88Us"};